/**
 * ai.sanity - simple validation of AI responses against expected keys and destructive action checks
 */
module.exports = function sanity(response = {}) {
  const warnings = []
  const requiredKeys = ['intent','response','capabilities']
  requiredKeys.forEach(k => { if (!response[k]) warnings.push(`missing ${k}`) })

  // detect destructive verbs in recommended_actions
  const destructive = ['delete','rollback','destroy']
  const actions = response.recommended_actions || []
  actions.forEach(a => {
    destructive.forEach(d => { if (String(a).toLowerCase().includes(d)) warnings.push(`destructive action suggested: ${a}`) })
  })

  // crude similarity score
  const score = response.intent && response.response ? 0.6 + Math.min(0.4, (response.response.length || 0) / 1000) : 0.2
  return { ok: warnings.length === 0, warnings, score }
}
